
import { defineComponent } from 'vue'
import KnFabButton from '@/components/UI/KnFabButton.vue'
import Message from 'primevue/message'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import descriptor from './QBEDialogsDescriptor.json'

export default defineComponent({
    name: 'olap-custom-view-save-dialog',
    components: { KnFabButton, Dialog, Message, Dropdown, DataTable, Column, Checkbox },
    props: { propDataset: { type: Object, required: true }, visible: Boolean },
    emits: ['close', 'save'],
    computed: {
        hasDuplicates(): any {
            var hasDuplicate = false
            this.dataset.pars
                .map((param) => param.name)
                .sort()
                .sort((a, b) => {
                    if (a === b) hasDuplicate = true
                })
            return hasDuplicate
        }
    },

    data() {
        return {
            descriptor,
            dataset: {} as any,
            initialParsState: [] as any,
            datasetParamTypes: descriptor.paramDialog.datasetParamTypes
        }
    },
    watch: {
        propDataset() {
            this.dataset = this.propDataset
            this.initialParsState = JSON.parse(JSON.stringify(this.propDataset.pars))
        }
    },
    created() {
        this.dataset = this.propDataset
        this.initialParsState = JSON.parse(JSON.stringify(this.propDataset.pars))
    },
    methods: {
        addNewParam() {
            if (this.dataset.isPersisted) {
                this.$confirm.require({
                    message: this.$t('managers.datasetManagement.disablePersistenceMsg'),
                    header: this.$t('managers.datasetManagement.disablePersistence'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.dataset.isPersisted = false
                        this.dataset.persistTableName = null
                        this.insertParameter()
                    }
                })
            } else {
                this.insertParameter()
            }
        },
        insertParameter() {
            this.dataset.pars ? '' : (this.dataset.pars = [])
            const newParam = { ...descriptor.paramDialog.newParam }
            this.dataset.pars.push(newParam)
        },
        deleteParam(removedParam) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.uppercaseDelete'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => (this.dataset.pars = this.dataset.pars.filter((paramToRemove) => removedParam.data.name !== paramToRemove.name))
            })
        },
        removeAllParams() {
            this.$confirm.require({
                message: this.$t('managers.datasetManagement.deleteAllParamsMsg'),
                header: this.$t('managers.datasetManagement.deleteAllParams'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => (this.dataset.pars = [])
            })
        },
        cancelChanges() {
            this.dataset.pars = JSON.parse(JSON.stringify(this.initialParsState))
            this.$emit('close')
        },
        onDefaultValueChange(parameter: any) {
            parameter.defaultValueChanged = true
        },
        saveParameters() {
            this.dataset.pars?.forEach((parameter: any) => {
                if (parameter.defaultValueChanged) {
                    delete parameter.value
                    delete parameter.defaultValueChanged
                }
            })
            this.$emit('save')
        }
    }
})
